import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6zicjtg87q: FaireBrandEntity = {
  token: "b_6zicjtg87q",
  type: "brand",
  name: "Most Amazing",
  avatarUrl:
    "https://cdn.faire.com/fastly/a678a165eeb47f07cd22ef320ce119ccb5269078e71f9d6f8fb4ed478c2db8cd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f61ef3d95bd554c97460717f4355fafd84e0e1e53daac13068512364bb073fc7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a678a165eeb47f07cd22ef320ce119ccb5269078e71f9d6f8fb4ed478c2db8cd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f61ef3d95bd554c97460717f4355fafd84e0e1e53daac13068512364bb073fc7.jpeg",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 395,
  isTopShop: true,
  isInsider: true,
  description:
    "Most Amazing was started by Jaysun, a product designer from Southern California.  After 20+ years as owner of Sik World, an adult novelty clothing line, he wanted to try something that allowed more creativity so he joined a MakerPlace, learned about laser cutters and developed the line you see here. \n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:17.876Z",
    importedBy: "entity-db-cli",
  },
};
